export const ADMIN = 'admin'
export const SUPPER_ADMIN = 'superAdmin'
export const FARMER = 'farmer'
export const CONSULTANT = 'consultant'
